// Vendor libraries
import { SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
const _forTrack0 = ($index, $item) => $item.id;
function GuidedWorkflowsStepsComponent_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "li", 3);
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", step_r1.text_content, i0.ɵɵsanitizeHtml);
} }
function GuidedWorkflowsStepsComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelement(1, "a", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r1.subcategory.knowledge_base_link_url, i0.ɵɵsanitizeUrl)("textContent", ctx_r1.subcategory.knowledge_base_link_text);
} }
/**
 *
 * Guided Workflows Steps Component
 * Display the steps of a guided workflow.
 *
 *
 * Input Properties:
 *   steps: list of GuidedWorkflowStep to display.
 *   subcategory: the GuidedWorkflowSubcategory the steps belong to.
 *   categoryTitle: the title of the category
 *
 */
export class GuidedWorkflowsStepsComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.sanitizedSteps = [];
    }
    ngOnChanges(changes) {
        if (changes.steps) {
            this.sanitizedSteps = this.steps.map((step) => ({
                ...step,
                text_content: this.sanitizer.bypassSecurityTrustHtml(step.text_content),
            }));
        }
    }
}
GuidedWorkflowsStepsComponent.ɵfac = function GuidedWorkflowsStepsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsStepsComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer)); };
GuidedWorkflowsStepsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedWorkflowsStepsComponent, selectors: [["ycn-guided-workflows-steps"]], inputs: { categoryTitle: "categoryTitle", subcategory: "subcategory", steps: "steps" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [[1, "mb-2", "mt-2", "text-bold", "text-gray-30", 3, "textContent"], [1, "divider-horizontal", "mt-2", "mb-2"], [1, "pl-2", "mb-row"], [1, "mb-20", 3, "innerHTML"], ["target", "_blank", 1, "text-blue", "text-underline-hover", 3, "href", "textContent"]], template: function GuidedWorkflowsStepsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "p", 0)(1, "hr", 1);
        i0.ɵɵelementStart(2, "ol", 2);
        i0.ɵɵrepeaterCreate(3, GuidedWorkflowsStepsComponent_For_4_Template, 1, 1, "li", 3, _forTrack0);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "hr", 1);
        i0.ɵɵtemplate(6, GuidedWorkflowsStepsComponent_Conditional_6_Template, 2, 2, "p");
    } if (rf & 2) {
        i0.ɵɵproperty("textContent", ctx.subcategory.title);
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.sanitizedSteps);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.subcategory.knowledge_base_link_text && ctx.subcategory.knowledge_base_link_url ? 6 : -1);
    } }, encapsulation: 2 });
